const internals = {};

exports.createOfflineConfirmation = ({
    http,
    isDeviceOffline,
    onOffline = () => {},
    onOnline = () => {},
    delay = 1000
}) => {

    let timer = null;
    let probeInProgress = false;
    let generation = 0;

    const suspect = () => {

        if (timer || probeInProgress) {
            return;
        }

        const probeGeneration = generation;

        timer = setTimeout(async () => {

            timer = null;

            if (probeGeneration !== generation || !isDeviceOffline()) {
                return;
            }

            probeInProgress = true;

            try {
                await http.get('/ping', {
                    connectivityProbe: true,
                    timeout: 2000
                });

                if (probeGeneration === generation) {
                    onOnline();
                }
            }
            catch (error) {
                if (probeGeneration !== generation) {
                    return;
                }

                if (error?.response) {
                    onOnline();
                }
                else if (isDeviceOffline()) {
                    onOffline();
                }
            }
            finally {
                probeInProgress = false;
            }
        }, delay);
    };

    const clear = () => {

        ++generation;

        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
    };

    const online = () => {

        clear();

        onOnline();
    };

    return {
        clear,
        dispose: clear,
        online,
        suspect
    };
};
